import { Button, Alert } from 'react-bootstrap';
import { FaDownload, FaFileAlt, FaCheckCircle } from 'react-icons/fa';

const DownloadInvoiceButtons = ({ order }) => {
    const contifico = Array.isArray(order?.contifico) ? order.contifico[0] : order?.contifico;
    const rideUrl = contifico?.urlRide || contifico?.rideUrl || contifico?.raw?.url_ride;
    const xmlUrl = contifico?.urlXml || contifico?.xmlUrl || contifico?.raw?.url_xml;
    const isAuthorized = contifico?.status === 'AUTHORIZED' || Boolean(rideUrl || xmlUrl);

    // Show download block when invoice is authorized or links are already available
    if (!contifico || !isAuthorized || !rideUrl) {
        return null;
    }

    return (
        <Alert variant="success" className="invoice-authorized-card mb-3 border-0 shadow-sm">
            <div className="invoice-authorized-header">
                <div className="invoice-authorized-icon" aria-hidden="true">
                    <FaCheckCircle size={18} />
                </div>
                <div>
                    <p className="invoice-authorized-kicker mb-1">Comprobante electrónico</p>
                    <h6 className="invoice-authorized-title mb-0">Factura autorizada por el SRI</h6>
                </div>
            </div>

            <div className="invoice-authorized-meta">
                {(contifico.documentNumber || contifico?.raw?.documento) && (
                    <p className="mb-1">
                        <span className="meta-label">No. Factura:</span>{' '}
                        {contifico.documentNumber || contifico?.raw?.documento}
                    </p>
                )}

                {contifico.authorizationDate && (
                    <p className="mb-0">
                        <span className="meta-label">Autorizada:</span>{' '}
                        {new Date(contifico.authorizationDate).toLocaleString('es-EC')}
                    </p>
                )}
            </div>

            <div className="invoice-authorized-actions">
                <Button
                    variant="success"
                    size="sm"
                    onClick={() => window.open(rideUrl, '_blank')}
                    className="d-inline-flex align-items-center justify-content-center gap-2"
                >
                    <FaDownload /> Descargar PDF
                </Button>
                {xmlUrl && (
                    <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() => window.open(xmlUrl, '_blank')}
                        className="d-inline-flex align-items-center justify-content-center gap-2"
                    >
                        <FaFileAlt /> Descargar XML
                    </Button>
                )}
            </div>
        </Alert>
    );
};

export default DownloadInvoiceButtons;
